module.exports = __webpack_public_path__ + "img/MC-Logo-Web-Color-StackedTagline.d7615e6.png";